var render = function render(){var _vm=this,_c=_vm._self._c;return _c('d-select-option',{attrs:{"options":_vm.options,"class-name":"background-light-blue-inputs"},on:{"on:select-option:change":function($event){return _vm.$emit('on:select-option:change', $event)}},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }